// © Microsoft Corporation. All rights reserved.
/**
 * Singleton class to store client browser data sent through query param to Render Service.
 * This is only used under server environment.
 */
class RequestData {
    /**
     * Initialize the request data instance with passed in client properties
     */
    constructor(data) {
        this.url = new URL(data.href);
        this.innerHeight = data.innerHeight;
        this.devicePixelRatio = data.devicePixelRatio;
        this.canUseCssGrid = data.canUseCssGrid;
        this.requestId = data.requestId;
        this.cookie = data.cookie;
        this.referer = data.referer;
    }
    /**
     * Returns singleton class instance.
     * @returns RequestData
     */
    static getInstance() {
        if (global["TEST_ENV"] && !RequestData._instance) {
            resetRequestData({
                href: "http://localhost:8080/",
                innerHeight: 768,
                devicePixelRatio: 1,
                canUseCssGrid: false,
                requestId: "0",
                cookie: "",
                referer: ""
            });
        }
        if (!RequestData._instance) {
            // Throw error if the request data has not been set as this should never be the case.
            // This likely highlights that the request data was not initialized when handling a
            // request when server side rendering.
            // TODO - http://osgvsowi/24832691 renable throwing an error.
            // This is currently disabled as other singletons that are initialized at import time use
            // this they will throw an error before anyone has the chance to initialize the request data
            resetRequestData({
                href: "http://localhost:8080/",
                innerHeight: 0,
                devicePixelRatio: 0,
                canUseCssGrid: false,
                requestId: "0",
                cookie: "",
                referer: ""
            });
            // throw new Error("Request data is not initialized yet through ResetInstance.");
        }
        return RequestData._instance;
    }
    /**
     * Reset singleton class instance with passed in info and client settings
     * @returns RequestData
     */
    static resetInstance(data) {
        RequestData._instance = new RequestData(data);
        return RequestData._instance;
    }
}
/**
 * The single instance of the RequestData class.
 * @type {RequestData}
 */
RequestData._instance = null;
/**
 * Export function to reset the request data singleton.
 * This must be used to set the request data.
 */
export const resetRequestData = RequestData.resetInstance;
/**
 * Export get instance function for testing
 */
export const getRequestData = () => (RequestData.getInstance());
//# sourceMappingURL=requestData.js.map